import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS_withoutToken } from "./api-base"
import { getESGReqHeader } from "./tool-service";

export const registerAcct = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010101'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010101")}`, method: 'post', data: ReqBody })
}

export const registerTaxIdNum = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010102'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010102")}`, method: 'post', data: ReqBody })
}


//註冊主帳戶/子帳戶 區分 主/子帳戶
export const registerMainSubAcct = async (reqBody,identity='master') => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010103'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010103")}/${identity}`, method: 'post', data: ReqBody })
}

//註冊主帳戶/子帳戶 統一檢核 步驟1 before
export const F0010101Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010101'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010101",true)}`, method: 'post', data: ReqBody })
}

export const F0010102Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010102'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010102",true)}`, method: 'post', data: ReqBody })
}


//註冊主帳戶/子帳戶 統一檢核區分主子帳戶 before master or slave
export const F0010103Before = async (identity='master') => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010103'),
        ReqBody: {}
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010103")}/before/${identity}`, method: 'post', data: ReqBody })
}



//忘記帳號/密碼
export const forgotAccOrPwd = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0020201'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0020201")}`, method: 'post', data: ReqBody })
}

//忘記帳號/密碼 統一檢核
export const F0020201Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0020201'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0020201",true)}`, method: 'post', data: ReqBody })
}

// F0020202: 驗證OTP取得帳號密碼
export const verifyOPTCode = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0020202'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0020202")}`, method: 'post', data: ReqBody })
}

// F0020202: 驗證OTP取得帳號密碼 統一檢核
export const F0020202Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0020202'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0020202",true)}`, method: 'post', data: ReqBody })
}

export const queryIndustryList = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010104'),
        ReqBody: {}
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010104")}`, method: 'post', data: ReqBody })
}

export const getRecaptchaSiteverify = async (recaptchaToken) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000301'),
        ReqBody: {
            recaptchaToken
        }
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0000301")}`, method: 'post', data: ReqBody })
}

export const queryLocaleList = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010105'),
        ReqBody: {}
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010105")}`, method: 'post', data: ReqBody })
}

export const queryCountryList = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0010106'),
        ReqBody: {}
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0010106")}`, method: 'post', data: ReqBody })
}



